export default "__VITE_ASSET__wwiEaygN__"